import React from "react";
import { SectionLabel } from "./ui";

const QUOTES = [
  { q: "We replaced a 14-person collections team with one agent and one supervisor. DSO dropped 18 days in the first quarter. We didn't lay anyone off — we redeployed them to growth.", who: "CFO", where: "Regional FMCG distributor · Southeast Asia", stat: { v: "−18d", l: "DSO in Q1" } },
  { q: "EkkBaz built a supplier-onboarding agent in five weeks. It's now processing more suppliers per week than our previous team did per quarter — with a 100% audit trail.", who: "Head of Procurement", where: "Electronics OEM", stat: { v: "9.2×", l: "throughput" } },
  { q: "Our concierge agent doesn't just answer — it actually fixes the guest's problem before they finish typing. Repeat-stay rate is up 11 points.", who: "VP Operations", where: "Boutique hotel group · 22 properties", stat: { v: "+11pts", l: "repeat-stay" } },
];

export default function TestimonialsSection() {
  return (
    <section id="proof" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <SectionLabel>Customer proof</SectionLabel>
          <h2 className="mt-5 text-[36px] leading-[1.05] tracking-tight sm:text-[44px] lg:text-[52px]">
            <span className="text-white">Operators who </span>
            <span className="font-display italic grad-text">stopped firefighting.</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          {QUOTES.map((q, i) => (
            <figure key={i} className="relative flex flex-col rounded-2xl border border-white/[0.08] bg-white/[0.025] p-7 hover:border-white/15">
              <div className="font-display text-[60px] leading-none text-cyan-300/30">&ldquo;</div>
              <blockquote className="mt-1 text-[15.5px] leading-relaxed text-white/85">{q.q}</blockquote>
              <div className="mt-6 grid grid-cols-[auto,1fr] gap-3 items-center">
                <div className="h-10 w-10 rounded-full placeholder-stripe border border-white/15" />
                <div>
                  <div className="text-[13.5px] font-semibold text-white">{q.who}</div>
                  <div className="text-[12px] text-white/50">{q.where}</div>
                </div>
              </div>
              <div className="mt-6 flex items-center justify-between border-t border-white/[0.06] pt-4">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">verified outcome</div>
                <div className="text-right">
                  <div className="text-[22px] font-semibold tracking-tight nums grad-text">{q.stat.v}</div>
                  <div className="text-[11px] text-white/45">{q.stat.l}</div>
                </div>
              </div>
            </figure>
          ))}
        </div>
        <div className="mt-10 grid items-center gap-6 rounded-2xl border border-white/[0.08] bg-[#070d24] p-7 lg:grid-cols-[1fr,auto]">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-cyan-300/80">featured customer outcome</div>
            <div className="mt-1 text-[20px] font-semibold text-white">How a Retail Business in the USA cut $600K Annually with AI Agents replacing human labour work</div>
          </div>
          <a href="#book" className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-5 py-2.5 text-[13.5px] font-semibold text-white hover:bg-white/[0.08]">Talk to us about your numbers →</a>
        </div>
      </div>
    </section>
  );
}
